import { cn } from "@/libs/utils";

type Props = {
  src: string | any;
  alt: string;
  className?: string;
  onClick?: () => void;
};
export default function CommonImg({
  src,
  alt,
  className = "",
  onClick,
}: Props) {
  return (
    <img
      src={src as string}
      alt={alt}
      className={cn("size-4", className)}
      onClick={() => onClick?.()}
    />
  );
}
